module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_icons/icn-ir-library-4d047db1e10fdd8ba645fb3a7c7ae4fd.svg";